import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import ShopPage from './pages/ShopPage';
import './styles.css';
import './shop.css';

function normalizePath(pathname) {
  const path = (pathname || '/').replace(/\/$/, '') || '/';
  if (path === '/shop' || path === '/shop.html') return '/shop';
  return '/';
}

function Root() {
  const route = normalizePath(window.location.pathname);
  if (route === '/shop') return <ShopPage />;
  return <App />;
}

createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <Root />
  </React.StrictMode>
);
